<template>
  <div
    :class="['notice_item', isread === 1 ? 'notice_read' : '']"
    @click="changeReadStatus({id, index, title, inquiryid, isread, attribute})"
  >
    <div class="l_time">
      <p v-text="date" />
      <p v-text="time" />
    </div>
    <div class="r_content">
      <h2
        class="content_title"
        v-text="title"
      />
      <p>{{ content }}</p>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import i18n from '@/lib/language'
export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    date: {
      type: String,
      default: '2019-07-01'
    },
    time: {
      type: String,
      default: '00:00:00'
    },
    title: {
      type: String,
      default: i18n.t('message["1215"]')
    },
    content: {
      type: String,
      default: ''
    },
    isread: {
      type: Number,
      default: 0
    },
    inquiryid: {
      type: Number,
      default: 0
    },
    attribute: {
      type: [Object, Array],
      default: () => ({})
    }
  },
  data () {
    return {
    }
  },
  methods: {
    changeReadStatus (data) {
      this.$emit('click', data)
    }
  }
}
</script>

<style scoped lang="scss">
.notice_read {
  p, h2 {
    color: #666 !important;
    font-weight: 400 !important;
  }
}
.notice_item::after {
  content: '';
  display: block;
  clear: both;
}
.notice_item {
  min-height: 80px;
  border-top: 1px solid #EBEBEB;
  background: #fff;
  overflow: hidden;
  padding: 16px 0;
  display: flex;
  flex-direction: row;
  p, h2 {
    color: #333;
    font-weight: 600;
  }
  .l_time {
    width: 110px;
    height: 48px;
    margin-left: 12px;
    p {
      line-height: 24px;
    }
  }
  .r_content {
    width: 694px;
    margin-left: 10px;
    font-size: 14px;
    line-height: 24px;
  }
}
.notice_item:hover {
  background: #F5F6F7;
  cursor: pointer;
}
</style>
